import { mergeMap, map, filter, take, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { isAuthenticatedSelector } from '@cbridge-packages/auth';
import { queryParamSelector } from '@cbridge-packages/routing';
import { PageContextAction } from '@cbridge-packages/page-context';
import { SearchParam } from '../_helpers/searchParam';
import { SearchFilterAction } from '../searchFilter.action';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>
  & IGetSelectorStateType<typeof isAuthenticatedSelector>;

export const initSearchFilterEpic: IEpic<IState> = (action$, state$) => {
  return state$.pipe(
    map((state) => ({
      searchString: queryParamSelector(state, SearchParam.name),
      isAuthenticated: isAuthenticatedSelector(state),
    })),
    filter(({ searchString, isAuthenticated }) => searchString && isAuthenticated),
    distinctUntilChanged(),
    take(1),
    mergeMap(({ searchString }) => {
      return [
        SearchFilterAction.setSearch(searchString),
      ];
    }),
    takeUntil(
      action$.pipe(
        isTypeOf(PageContextAction.init.done, PageContextAction.init.failed),
      ),
    ),
  );
};
